import { useEffect, useState } from "react";
import { TextView } from "../../view-form-components/text-view";
import ViewLocationMap from "../../view-form-components/location-view";
import { api } from "../../../redux/apis/api";

const CustomerDeliveryAddressViewModal = ({
  isOpen = false,
  onClose = () => {},
  onDeleteFnc = () => {},
  selectID,
  deleteDisable = true,
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/customer/delivery-address/read`, {
        id: selectID,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectID && isOpen === true) {
      fetchData();
    }
  }, [selectID, isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[50rem] w-full md:p-8 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                customer delivery-address activity - view
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                {deleteDisable && (
                  <button
                    onClick={onDeleteFnc}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor bg-errorColor text-white rounded"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
            <section className="overflow-auto w-full h-[60vh]">
              <section className="w-full max-w-[40rem]">
                <div className="px-2">
                  <TextView label={"customer"} value={data?.customer?.name} />
                </div>
                <div className="px-2">
                  <TextView label={"name"} value={data?.name} />
                </div>
                <div className="px-2">
                  <TextView label={"address"} value={data?.address} />
                </div>
                <div className="px-2">
                  <TextView label={"state"} value={data?.state?.name} />
                </div>
                <div className="px-2">
                  <TextView label={"city"} value={data?.city?.name} />
                </div>
                <div className="px-2">
                  <TextView label={"pincode"} value={data?.pincode} />
                </div>
                <ViewLocationMap
                  label={"location"}
                  lat={data?.location?.lat ?? ""}
                  lng={data?.location.lng ?? ""}
                />
              </section>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerDeliveryAddressViewModal;
